import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import { api } from "../lib/api";

/**
 * Daily Pattern card — surfaces today's auto-generated non-obvious connection between two
 * dossiers from different categories. AI builds it once per day (cached server-side), so
 * every visitor sees the same insight until tomorrow.
 */
export default function DailyPattern() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get("/ai/daily-pattern")
      .then((r) => setData(r.data))
      .catch(() => setErr(true));
  }, []);

  if (err) return null;
  if (!data) return null;

  const [a, b] = data.subjects || [];
  if (!a || !b) return null;

  return (
    <section data-testid="daily-pattern" className="my-12 max-w-4xl mx-auto px-4 sm:px-0">
      <div className="border border-[#ffd60a]/40 bg-gradient-to-br from-[#ffd60a]/[0.06] to-[#a78bfa]/[0.04] p-5 sm:p-8">
        <div className="flex items-center gap-2 mb-3">
          <Sparkles size={14} className="text-[#ffd60a]" />
          <div className="font-mono text-[10px] tracking-[0.25em] text-[#ffd60a]">
            // PATTERN OF THE DAY · {data.date}
          </div>
        </div>
        <div className="grid sm:grid-cols-2 gap-3 mb-4">
          <Link to={a.route || `/dossier/${a.slug}`} data-testid="daily-pattern-a"
            className="block border border-white/10 bg-[#0a0a0a] p-3 hover:border-[#ffd60a]/40 transition-colors">
            <div className="font-mono text-[9px] tracking-[0.25em] text-zinc-500">A · {(a.category || "FILE").replaceAll("_", " ").toUpperCase()}</div>
            <div className="font-heading text-white text-base mt-1 truncate">{a.title}</div>
          </Link>
          <Link to={b.route || `/dossier/${b.slug}`} data-testid="daily-pattern-b"
            className="block border border-white/10 bg-[#0a0a0a] p-3 hover:border-[#ffd60a]/40 transition-colors">
            <div className="font-mono text-[9px] tracking-[0.25em] text-zinc-500">B · {(b.category || "FILE").replaceAll("_", " ").toUpperCase()}</div>
            <div className="font-heading text-white text-base mt-1 truncate">{b.title}</div>
          </Link>
        </div>
        <p className="text-zinc-200 leading-relaxed text-sm sm:text-base whitespace-pre-wrap">{data.insight}</p>
        <Link to="/archive" className="inline-flex items-center gap-1 mt-4 font-mono text-[10px] tracking-[0.25em] text-[#ffd60a] hover:text-white transition-colors">
          // PULL ANOTHER THREAD <ArrowRight size={11} />
        </Link>
      </div>
    </section>
  );
}
